import React from 'react'
import {RESERVATION_STATUS} from '../../../CodeMaster'
import styled, {css} from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'

interface Props {
    reservationStatus: RESERVATION_STATUS
}

const ReservationStatusTag: React.FC<Props> = props =>
    <StyledStatusTag {...props}>{props.reservationStatus.label}</StyledStatusTag>

ReservationStatusTag.displayName = 'ReservationStatusTag'
export default ReservationStatusTag

const StyledStatusTag = styled.div<Props>`
  width: 70px;
  height: 18px;
  line-height: 18px;
  font-size: ${FontSize.Small};
  font-weight: ${FontWeights.Light};
  color: ${props => props.reservationStatus === RESERVATION_STATUS.BEFORE_LOTTERY ? Colors.Body : Colors.Surface};
  text-align: center;
  display: inline-block;
  background: ${props => {
    switch (props.reservationStatus.value) {
        case RESERVATION_STATUS.ELECTION.value:
            return css`linear-gradient(166deg, rgb(0, 145, 136) 50%, #00838a 50%)`
        case RESERVATION_STATUS.BEFORE_LOTTERY.value:
            return css`rgb(228,240,247)`
        case RESERVATION_STATUS.CANCEL.value:
            return css`rgb(112,112,112)`
        case RESERVATION_STATUS.DIS_ELECTION.value:
            return css`rgb(112,112,112)`
        case RESERVATION_STATUS.WAITING_FOR_CONFIRMATION.value:
            return css`linear-gradient(166deg, rgb(239, 103, 35) 50%, rgb(216, 91, 28) 50%)`
        default:
            return css`rgb(255, 0, 0)`
    }
}};
`

export const GrayedStatusTag = styled.div`
  width: 58px;
  min-width: 58px;
  height: 18px;
  font-size: ${FontSize.Small};
  font-weight: ${FontWeights.Light};
  line-height: 18px;
  color: ${Colors.Body};
  text-align: center;
  display: inline-block;
  background: ${Colors.Background};
`
